// @ts-nocheck
/* Starter Sync - SettingsMenu */

import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import NavigationModeMenu, {
    NavigationModeCookieName,
    NavigationModeMenuStyles,
} from "@insite/content-library/Components/NavigationModeMenu";
import ShowInventoryToggle, { ShowInventoryToggleStyles } from "@insite/content-library/Components/ShowInventoryToggle";
import ShowPricingToggle, { ShowPricingToggleStyles } from "@insite/content-library/Components/ShowPricingToggle";
import Hidden from "@insite/mobius/Hidden";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import * as cssLinter from "css";
// import React, { FC } from "react"; // Starter Custom Code
import { connect } from "react-redux";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import { headerHideForMobileStyles } from "@store/Themes/common/mixins/header";
import { menuSecondaryNavigationItemStyles } from "@store/Themes/common/mixins/menu";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, useContext, useMemo } from "react";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const enum fields {
    customCSS = "customCSS",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.customCSS]: string;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
    displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
    currentMode: getCookie(NavigationModeCookieName) || "Storefront",
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

/* Starter Removed - Navigation */

/* Starter Removed - NavItem */

export interface SecondaryNavigationStyles {
    wrapper?: InjectableCss;
    navigationModeMenu?: NavigationModeMenuStyles;
    showInventoryLink?: InjectableCss;
    showInventoryToggle?: ShowInventoryToggleStyles;
    showPricingLink?: InjectableCss;
    showPricingToggle?: ShowPricingToggleStyles;
    currencyLink?: InjectableCss;
    languageLink?: InjectableCss;
    warehousePickupLink?: InjectableCss;
    signInLink?: InjectableCss;
    // Starter Custom Code
    innerWrapper?: InjectableCss;
    section?: InjectableCss;
    // Store Custom Code
    rightSection?: InjectableCss;
}

export const secondaryNavigationStyles: SecondaryNavigationStyles = {
    wrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            position: relative;
            z-index: 1;
            ${x => breakpointValues(x.theme.design.menu.secondaryNavigation.height, "height")}
            background-color: ${getColor("menu.secondaryNavigation")};
            color: ${getColor("menu.secondaryNavigation.contrast")};
            font-size: ${x => x.theme.design.typography.size.smaller};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    innerWrapper: {
        css: css`
            ${siteWidthStyles()}
            display: flex;
            justify-content: space-between;
            height: inherit;
        `,
    },
    section: {
        css: css`
            display: flex;
            align-items: center;
            flex-shrink: 0;

            ${({ theme }) =>
                breakpointValues(
                    theme.design.menu.secondaryNavigation.itemSpacing.map(x => (x !== null ? `calc(${x} / 2)` : null)),
                    ["margin-right", "margin-left"],
                )}

            > [class^="Wrapper-"] /* Zone */ {
                ${menuSecondaryNavigationItemStyles()}
                display: flex;
                align-items: center;
                width: auto;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        `,
    },
    /* Store Custom Code - Start */
    rightSection: {
        css: css`
            display: flex;
            align-items: center;
            flex-shrink: 0;
            margin: 0 calc(${x => x.theme.design.menu.secondaryNavigation.itemSpacing} / 2);

            > [class^="Wrapper-"] /* Zone */ {
                ${menuSecondaryNavigationItemStyles()}
                display: flex;
                align-items: center;
                height: 100%;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        `,
    },
    /* Store Custom Code - End */
};

/* Starter Custom Code - Start */
const defaultCustomCss = `& {
}

.wrapper {
}

.zone-left {
}

.zone-right {
}`;
/* Starter Custom Code - End */

const SecondaryNavigation: FC<Props> = ({
    id,
    enableWarehousePickup,
    displayPricingAndInventory,
    currentMode,
    fields,
}) => {
    const styles = useMergeStyles("secondaryNavigation", secondaryNavigationStyles);

    /* Starter Custom Code - Start */
    const { isEditing, isInShell } = useContext(ShellContext);

    const wrapperCss = useMemo(() => {
        return css`
            ${styles.wrapper?.css}
            ${isEditing ? "height: auto;" : null}
            ${!isEditing && isInShell ? "[data-widget] { height: 100%; }" : null}
	        ${fields.customCSS}
        `;
    }, [styles, isEditing, isInShell, fields.customCSS]);

    return (
        <StyledWrapper {...styles.wrapper} css={wrapperCss}>
            <StyledWrapper className="wrapper" {...styles.innerWrapper}>
                <StyledWrapper className="zone-left" {...styles.section}>
                    <Zone zoneName="Left" contentId={id} />
                </StyledWrapper>
                <StyledWrapper className="zone-right" {...styles.rightSection} /* Store Custom Code */>
                    <Zone zoneName="Right" contentId={id} />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
    /* Starter Custom Code - End */
};

const secondaryNavigation: WidgetModule = {
    component: connect(mapStateToProps)(SecondaryNavigation),
    definition: {
        group: "Common",
        icon: "link-simple",
        fieldDefinitions: [
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            // Starter Removed - showPricingToggle
            // Starter Removed - showInventoryToggle
        ],
    },
};

export default secondaryNavigation;
